





















































import { Component, Vue, Prop } from 'vue-property-decorator';

import TextField from '@/components/atoms/TextField/TextField.vue';
import Arrow from '@/components/icons/Arrow.vue';
import eventBus from '@/utils/eventBus';

interface Option {
  id: string | number;
  label: string;
  value: any;
  disabled?: boolean;
}

@Component({
  components: { TextField, Arrow },
  $_veeValidate: {
    value() {
      const { value } = this as any;
      return value;
    },
    name() {
      const { name } = this as any;
      return name;
    }
  }
})
export default class Autocomplete extends Vue {
  @Prop() value!: any;
  @Prop() initialValue!: any;
  @Prop(String) readonly name!: string;
  @Prop(String) readonly tippy?: string;
  @Prop(String) readonly label!: string;
  @Prop(String) readonly placeholder!: string;
  @Prop({ default: [] }) readonly options!: Option[];
  @Prop({ default: false }) readonly error!: boolean;
  @Prop({ default: 'medium' }) size!: 'medium' | 'small';

  inputValue: string = '';
  debouncedValue: string = '';
  timeout: any;

  open: boolean = false;

  get filteredOptions() {
    if (this.size === 'small' && this.options) {
      return this.options.filter(option => option.label !== this.inputValue);
    }

    return this.options;
  }

  onClick(e: MouseEvent) {
    e.stopPropagation();
    this.open = !this.open;
  }

  onBlur($event?: any) {
    if ($event) {
      $event.stopPropagation();
      this.open = false;
    }
  }

  select(option: Option, $event: MouseEvent) {
    $event.stopPropagation();
    if (option.disabled) return;
    this.inputValue = option.label;
    this.$emit('input', option.value);
    this.open = false;
  }

  openOptions() {
    setTimeout(() => {
      this.open = true;
    });
  }

  created() {
    if (this.initialValue) {
      this.inputValue = this.initialValue;
    }

    eventBus.$on('openAutocomplete', this.openOptions);
  }

  destroy() {
    eventBus.$off('openAutocomplete', this.openOptions);
  }
}
